package com.milta.feature.route.domain.entity

/**
 * `route` header of `GET /api/v1/routes/{routeId}/proofs` (MIL-52, Screen B) — the tournée-level
 * info shown above the proofs grid ("Tournée du {date} · {driver}", "{total} livraisons · ...").
 */
data class RouteProofsSummary(
    /** `yyyy-MM-dd`. */
    val date: String,
    val driverFirstName: String,
    val driverLastName: String,
    val totalDeliveries: Int,
    val deliveredCount: Int,
    val failedCount: Int,
)
